import { notifUtils } from "../components/NotifUtils/NotifUtils";
import { handleError } from "../components/Utils/Utils";
import ReconciliationService from "../Services/ReconciliationService";

export const getReconciliationList = (store, value, refresh) => {
  const isLoading = !store.state.isLoading;
  const status = 200;
  const reconciliations = [];
  store.setState({ isLoading, status, reconciliations });

  return ReconciliationService.getReconciliationList(value)
    .then((response) => {
      let data = response.data;
      const isLoading = false;
      const status = response.status;
      store.state.lastPage = false;
      store.state.reconciliations = refresh ? data : store.state.reconciliations.concat(data);
      if (data.length < parseInt(value.num)) {
        store.state.lastPage = true;
      }
      store.setState({
        isLoading,
        header: response.headers,
        status,
      });
    })
    .catch((error) => {
      handleError(error);
    });
};

export const getFailedReconciliation = (store) => {
  const status = 200;
    const isLoadingResult = true;
    store.setState({ status, isLoadingResult });

    return ReconciliationService.getFailedReconciliation()
    .then((response) => {
      let data = response.data;
      const isLoadingResult = false;
      const status = response.status;
      store.state.reconciliationFailed = data;
      store.setState({
        isLoadingResult,
        header: response.headers,
        status,
      });
    })
    .catch((error) => {
      handleError(error);
    });
}

export const getSummaryReconciliation = (store) => {
  const status = 200;
    const isLoadingResult = true;
    store.setState({ status, isLoadingResult });

    return ReconciliationService.getSummaryReconciliation()
    .then((response) => {
      let data = response.data;
      const isLoadingResult = false;
      const status = response.status;
      store.state.reconciliationSummary = data;
      store.setState({
        isLoadingResult,
        header: response.headers,
        status,
      });
    })
    .catch((error) => {
      handleError(error);
    });
}

export const getDetailReconciliation = (store, id) => {
    const status = 200;
    const isLoadingResult = true;
    store.setState({ status, isLoadingResult });
  
    return ReconciliationService.getDetailReconciliation(id)
      .then((response) => {
        let data = response.data;
        const isLoadingResult = false;
        const status = response.status;
        store.state.reconciliation = data;
        store.setState({
          isLoadingResult,
          header: response.headers,
          status,
        });
      })
      .catch((error) => {
        handleError(error);
      });
  };

  export const patchReconciliationTransactionSettled = async (store, id, params, notif) => {
    try {
      const response = await ReconciliationService.patchReconciliationTransactionSettled(id, params);
      const data = response.data;
      notifUtils(notif, "success");
      return data;
    } catch (error) {
      handleError(error);
      return error;
    }
  };
